const Philosophy = () => {
  return (
    <section id="filosofia" className="py-20 bg-gradient-to-br from-primary-50 to-accent-50 relative overflow-hidden">
      {/* Elementos decorativos */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-gradient-to-br from-primary-200/30 to-accent-200/30 rounded-full -translate-x-32 -translate-y-32"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-to-tl from-accent-200/20 to-primary-200/20 rounded-full translate-x-48 translate-y-48"></div>
      
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-primary-800 mb-6">
            Nuestra Filosofía
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-primary-500 to-accent-500 mx-auto rounded-full"></div>
        </div>

        <div className="bg-white/80 backdrop-blur-sm rounded-3xl shadow-2xl p-8 md:p-12 border border-white/50">
          <div className="max-w-4xl mx-auto">
            {/* Cita principal */}
            <div className="text-center mb-12">
              <div className="w-16 h-16 bg-gradient-to-br from-primary-500 to-accent-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-double-quotes-l text-white text-2xl"></i>
              </div>
              <blockquote className="text-xl md:text-2xl font-medium text-primary-700 leading-relaxed italic">
                "Una sola vara se quiebra al instante, pero un haz unido es irrompible"
              </blockquote>
              <cite className="text-primary-500 font-semibold mt-4 block">— Sabiduría Clásica</cite>
            </div>

            {/* Contenido principal */}
            <div className="space-y-8 text-lg leading-relaxed text-neutral-700">
              <p className="text-center font-semibold text-primary-800 text-xl">
                Esta antigua lección define el corazón de la veterinaria moderna.
              </p>
              
              <p>
                El individualismo profesional es esa vara solitaria: la trampa que nos hace frágiles 
                y limita nuestro verdadero potencial ante los desafíos más complejos. En un mundo 
                donde cada caso puede presentar nuevas complejidades, la colaboración no es solo 
                una opción, es una necesidad.
              </p>
              
              <div className="bg-gradient-to-r from-primary-50 to-accent-50 rounded-2xl p-8 border-l-4 border-primary-500">
                <p className="font-semibold text-primary-800 text-xl mb-4">
                  "Juntos somos más"
                </p>
                <p>
                  Esta es nuestra respuesta directa. Es el principio que nos convierte en una fuerza 
                  imparable, donde cada profesional, cada clínica, cada experiencia única aporta 
                  al crecimiento común de nuestra profesión.
                </p>
              </div>
              
              <p>
                La grandeza de la veterinaria se descubre en la sinergia: en esa colaboración 
                donde el conocimiento se multiplica, donde las experiencias se comparten y donde 
                crecemos juntos. Es ahí donde fortalecemos un gremio que, unido, puede superar 
                cualquier desafío que se presente.
              </p>
              
              <p className="text-center font-semibold text-primary-800">
                El verdadero avance no reside en el esfuerzo aislado, sino en construir esa unidad, 
                día a día, centro a centro, profesional a profesional.
              </p>
            </div>

            {/* Elementos visuales de unión */}
            <div className="mt-12 flex justify-center items-center space-x-4">
              <div className="flex -space-x-2">
                <div className="w-12 h-12 bg-gradient-to-br from-primary-400 to-primary-600 rounded-full border-4 border-white shadow-lg flex items-center justify-center">
                  <i className="ri-user-heart-line text-white text-lg"></i>
                </div>
                <div className="w-12 h-12 bg-gradient-to-br from-accent-400 to-accent-600 rounded-full border-4 border-white shadow-lg flex items-center justify-center">
                  <i className="ri-team-line text-white text-lg"></i>
                </div>
                <div className="w-12 h-12 bg-gradient-to-br from-primary-600 to-accent-600 rounded-full border-4 border-white shadow-lg flex items-center justify-center">
                  <i className="ri-heart-pulse-line text-white text-lg"></i>
                </div>
              </div>
              <div className="text-primary-600">
                <i className="ri-arrow-right-line text-2xl"></i>
              </div>
              <div className="w-16 h-16 bg-gradient-to-br from-primary-500 to-accent-500 rounded-full border-4 border-white shadow-xl flex items-center justify-center">
                <i className="ri-shield-check-line text-white text-xl"></i>
              </div>
            </div>

            <p className="text-center text-primary-600 font-medium mt-6">
              Colaboración • Excelencia • Crecimiento Conjunto
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Philosophy;
